import datacentral from '@/utils/axios/datacentral'
import { RecentObjectResponse, RecentObjectwithCursor } from '../../types'
import { ResponseArray, ResponseObject } from '@/types/shared'

export const ListRecentObject = async (
    uuid: string | undefined,
    cursor: string | null = null
): Promise<ResponseArray<RecentObjectResponse>> => {
    if (!uuid) return Promise.reject(new Error('UUID is required'))
    try {
        const response = await datacentral.get('drive/recent', {
            params: { uuid: uuid, cursor: cursor },
        })
        return response.data
    } catch (error: any) {
        throw new Error(
            error.response?.data?.message || 'Failed to fetch recent object'
        )
    }
}

export const ListRecentObjectWithCursor = async (
    uuid: string | undefined,
    cursor: string | null = null,
    search?: string
): Promise<ResponseObject<RecentObjectwithCursor>> => {
    search = search ?? ''
    if (!uuid) return Promise.reject(new Error('UUID is required'))
    try {
        const response = await datacentral.get(
            `drive/recent?uuid=${uuid}&cursor=${cursor}&search=${search}`
        )
        return response.data
    } catch (error: any) {
        throw new Error(
            error.response?.data?.message || 'Failed to fetch recent object'
        )
    }
}
